module.exports = __webpack_public_path__ + "img/bild-a.07a2169d.png";